import {
  CreateWorkRequest,
  DestinyItem,
  RequestItem,
  RequestShortInfo,
  RequestWorkStatistic,
  StatusChangeData,
  StatusItem,
} from '../bus/request/types';
import $axios from '../utils/axios-instance';

export default class RequestsApi {
  async createRequest(data: Omit<RequestItem, 'id'>) {
    return await $axios
      .post('/v1/Request', data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getRequestDetail(data: { id: number | string }) {
    return await $axios
      .get<RequestItem>(`/v1/Request/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async changeRequest(data: RequestItem) {
    return await $axios
      .put(`/v1/Request/${data.id}`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getRequestDestiny() {
    return await $axios
      .get<DestinyItem[]>('/v1/Request/Destiny')
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getRequestStatus(data: { id: number | string }) {
    return await $axios
      .get<StatusItem[]>(`/v1/Request/${data.id}/status`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async changeRequestStatus(data: StatusChangeData) {
    return await $axios
      .put<RequestItem>(`/v1/Request/${data.id}/status`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async deleteRequest(data: { id: number | string }) {
    return await $axios
      .delete(`/v1/Request/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async requestApproved(data: { id: number | string }) {
    return await $axios
      .post(`/v1/Request/${data.id}/Approve`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async requestStatuses(data: { id: number | string }) {
    return await $axios
      .get('/v1/Request/Statuses')
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async createWorkRequest(data: CreateWorkRequest) {
    return await $axios
      .post(`/v1/Request/${data.id!}/work`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async requestWorkDetail(data: { id: number | string }) {
    return await $axios
      .get(`/v1/RequestWork/${data.id!}/`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async requestWorkChange(data: CreateWorkRequest) {
    return await $axios
      .put(`/v1/RequestWork/${data.id!}/`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async requestWorkDelete(data: { id: number | string }) {
    return await $axios
      .delete(`/v1/RequestWork/${data.id!}/`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async requestWorkStatistic({ id }: { id: number | string }) {
    return await $axios
      .get<RequestWorkStatistic>(`/v1/Request/${id!}/statistic`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async requestWorkShortInfo({ id }: { id: number | string }) {
    return await $axios
      .get<RequestShortInfo>(`/v1/Request/shortInfo/${id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
  async requestWorkRedirect({ requestWorkId, requestId }: { requestId: number; requestWorkId: number }) {
    return await $axios
      .put(`/v1/RequestWork/redirect/${requestWorkId}`, { requestId })
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
}
